var borderRadii = {
  default: '0px'
};

export default borderRadii;
